window.addEventListener("DOMContentLoaded", initSearch, false);


function initSearch() {
    const searchForm = document.querySelector("#searchform");
    const queryInput = document.querySelector("#id_q");
    const searchResults = document.querySelector("#search-results");
    const searchDataURL = "/search/data.json";
    let specimens = null;

    let req = new XMLHttpRequest();
    req.open("GET", searchDataURL);
    req.responseType = 'json';
    req.send();

    req.onload = function() {
	specimens = req.response;
    };

    searchForm.addEventListener("submit", e => {
	e.preventDefault();
	
	const query = queryInput.value.toLowerCase();
	let results = [];

	specimens.forEach(specimen => {
	    if(specimen.title.toLowerCase().includes(query) || specimen.description.toLowerCase().includes(query)) {
		results.push(specimen);
	    }
	});

	searchResults.style.display = "block";
	searchResults.innerText = "";

	if(results.length === 0) {
	    let li = document.createElement('li');
	    li.innerHTML = "No matches found for <strong>" + query + "</strong>";
	    searchResults.append(li);
	} else {
	    results.forEach(result => {
		let li = document.createElement('li');
		let a = document.createElement('a');
		a.href = result.url;
		a.title = result.title;
		a.innerText = result.title;
		li.append(a);
		searchResults.append(li);
	    });
	}
	    
    }, false);
}
